angular.module('app').directive('recados', function($sce) {
	return {
        restrict: 'A',
        templateUrl: 'assets/admin/html/recados.html?v='+angular.element('meta[name="version-id"]').attr('content'),
        controller: function($scope, $element, $http, $timeout, $compile) {
            $scope.getMeusRecados = function(){
                $http.get('/admin/recados/lista/meus-recados').then(function(response) {
                    //First function handles success
                    $scope.recados = [];

                    for(var i in response.data.recados){            
                        $scope.recados[i] = {
                            'id': response.data.recados[i].id,
                            'titulo': response.data.recados[i].titulo,
                            'recado': $sce.trustAsHtml( response.data.recados[i].recado ),
                            'resumo': angular.element('<p>'+response.data.recados[i].recado+'</p>').text(),
                            'lido': response.data.recados[i].lido,
                            'created_at': response.data.recados[i].created_at,
                            'aberto': ''
                        };
                    }        
                    
                    window.setTimeout(function(){
                        angular.element('[ng-controller="recadosController"] .quantidade-recados-nao-lidos').removeClass('hide');    
                    }, 300);

                }, function(response) {
                    //Second function handles error
                    $scope.recados = [];
                    $scope.naolidos = '?';        
                });
            };

            $scope.naoLidos = function(){
                var naoLido = [];
                angular.forEach($scope.recados, function(recado){
                    if(!recado.lido) naoLido.push(recado);
                });

                return naoLido;
            };

            $scope.recadoLido = function(recado, recados){
                for(var i = 0; i<recados.length; i++){
                    recados[i].aberto = ''; 
                }       
                recados[recados.indexOf(recado)].lido = 1;
                recado.aberto = 'aberto';        

                $http({
                    method: 'PATCH',
                    url: '/admin/recados/marcar/lido',
                    data: {
                        'recado': recado.id
                    }
                });

            };
        },
        link: function ($scope, $element, attrs, ctrl) {
            $scope.getMeusRecados();

            $element.find('ul.dropdown-menu').on('click', function(e){		
                if($(e.target).prop('tagName')!='A' || $(e.target).hasClass('disabled') ){
                    e.preventDefault();
                    e.stopPropagation();
                }
            });

            $element.find(".dropdown-toggle").dropdown();
        }
    };
});